/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Button,
  ModalBody,
  ModalFooter,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  Flex,
  Select as SelectChakra,
  Spinner,
  Text,
} from '@chakra-ui/react';
import * as Yup from 'yup';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useLoading, Oval } from '@agney/react-loading';
import { MultiSelect } from 'react-multi-select-component';
import { apllyToast } from '../../../Global/Toast2.0';
import getValidationErrors from '../../../../utils/getValidationErrors';

import Select from '../../../Global/SelectRelease';

import Input from '../../../Global/Input';
import { ModalComponent } from '..';
import { api } from '../../../../services/api';
import { Internationalization } from '../../../../utils/InternationalizationMultSelect';
import { ListPermissions } from '../../Admin/ListPermissions';
import { ListRoles } from '../../Admin/ListRoles';
import { ConfigsAvanced } from './ConfigsAvanced';
import {
  LossControlRequestedScope,
  lossControlService,
} from '../../../../services/lossControlService';
import LossControlResponsibilitiesField from '../LossControlResponsibilitiesField';
import { useAccessControlUsers } from '../../../../hooks/useAccessControl';
import {
  accessControlError,
  accessControlService,
} from '../../../../services/accessControlService';
import {
  diffIds,
  filterOptions,
  plural,
  userLabel,
} from '../../../../utils/accessControl';

interface IUserEdited {
  name: string;
  nickname: string;
  email: string;
  ramal: string;
  phone: string;
  image: string;
  senior_id: string;
  job_position: string;
  sector_id: string;
  access_of_sector?: {
    id: string;
    name: string;
  };
}

interface IProps {
  id: string;
  isOpen: boolean;
  onClose: () => void;
}

interface IOptions {
  value: string;
  label: string;
  identification?: string;
  disabled?: boolean;
  existingData?: boolean;
}

// Seleção guardada pelos ids; o nome vem da lista de opções na hora de exibir
// (a lista pode chegar depois dos vínculos do usuário).
function toOptions(ids: string[]): IOptions[] {
  return ids.map(value => ({ value, label: value }));
}

function withLabels(selected: IOptions[], options: IOptions[]): IOptions[] {
  return selected.map(
    item =>
      options.find(option => option.value === item.value) || {
        ...item,
        label: 'Carregando...',
      },
  );
}

interface IOptionsSectors {
  value: string;
  label: string;
}

export function ModalEditUser({ id, onClose, isOpen }: IProps) {
  const formRef = useRef<FormHandles>(null);
  const [flag_01, set_flag_01] = useState(false);
  const [initialData, setInitialData] = useState<IUserEdited>();
  const [dataRoles, setDataRoles] = useState<IOptions[]>([]);
  const [dataPermissions, setDataPermissions] = useState<IOptions[]>([]);

  const [dataSelectesRoles, setSelectedDataRoles] = useState<IOptions[]>([]);
  const [dataSelectesPermissions, setSelectedDataPermissions] = useState<
    IOptions[]
  >([]);
  // Vínculos gravados quando o modal abriu; o salvar compara com eles para
  // adicionar o que foi marcado e remover o que foi desmarcado.
  const [linksState, setLinksState] = useState<'loading' | 'ready' | 'error'>(
    'loading',
  );
  const initialRoleIdsRef = useRef<string[]>([]);
  const initialPermissionIdsRef = useRef<string[]>([]);
  const [copyFrom, setCopyFrom] = useState('');
  const [copying, setCopying] = useState(false);
  const accessUsers = useAccessControlUsers();

  const componentRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);
  const [lossControlScopes, setLossControlScopes] = useState<
    LossControlRequestedScope[]
  >([]);

  const { containerProps, indicatorEl } = useLoading({
    loading,
    indicator: <Oval />,
  });

  const [sectorFormated, setSectorFormated] = useState<IOptionsSectors[]>([
    {
      label: '',
      value: '',
    },
  ]);

  const [sectorSelected, setSectorSelected] = useState({
    value: '',
    label: '',
  });

  useEffect(() => {
    api.get('/sectors').then(response => {
      const sectorFormateded: React.SetStateAction<any[]> = [];

      response.data.forEach(function (sector: { id: string; name: string }) {
        const option = {
          value: sector.id,
          label: sector.name,
        };
        sectorFormateded.push(option);
      });

      setSectorFormated(sectorFormateded);
    });
  }, []);

  useEffect(() => {
    api.get('/roles').then(resp => {
      const arrayRolesFormated: {
        value: string;
        label: string;
        identification: string;
      }[] = [];

      resp.data.forEach(
        (element: { id: string; name: string; identification: string }) => {
          const goal = {
            value: element.id,
            label: element.name,
            disabled: dataSelectesRoles.some(
              elem => elem.label === element.name,
            ),
            identification: element.identification,
          };

          arrayRolesFormated.push(goal);
        },
      );

      setDataRoles(arrayRolesFormated);
    });
  }, []);

  useEffect(() => {
    api.get('/permissions').then(resp => {
      const arrayPermissionsFormated: {
        value: string;
        label: string;
        identification: string;
      }[] = [];

      resp.data.forEach(
        (element: { id: string; name: string; identification: string }) => {
          const goal = {
            value: element.id,
            label: element.name,
            disabled: dataSelectesPermissions.some(
              elem => elem.label === element.name,
            ),
            identification: element.identification,
          };

          arrayPermissionsFormated.push(goal);
        },
      );

      setDataPermissions(arrayPermissionsFormated);
    });
  }, []);

  // Funções e permissões são carregadas pelos vínculos do usuário (ids), não
  // pela identificação: duas permissões podem ter a mesma identificação (ex.:
  // "Adicionar PIC" e "Adicionar novo PIV" são `user_pic_add`), e a busca pela
  // identificação marcava a errada.
  useEffect(() => {
    if (!isOpen || !id) {
      return undefined;
    }

    let active = true;

    setLinksState('loading');
    setSelectedDataRoles([]);
    setSelectedDataPermissions([]);

    Promise.all([
      api.get(`/accesses/show?access_id=${id}`),
      accessControlService.getAccessLinks(id),
    ])
      .then(([accessResponse, links]) => {
        if (!active) {
          return;
        }

        const { access } = accessResponse.data;

        setInitialData(access);
        if (access.access_of_sector) {
          setSectorSelected({
            value: access.access_of_sector.id,
            label: access.access_of_sector.name,
          });
        }
        set_flag_01(access.flag_1);

        initialRoleIdsRef.current = links.roles_ids;
        initialPermissionIdsRef.current = links.permissions_ids;
        setSelectedDataRoles(toOptions(links.roles_ids));
        setSelectedDataPermissions(toOptions(links.permissions_ids));
        setLinksState('ready');
      })
      .catch(err => {
        if (!active) {
          return;
        }

        setLinksState('error');
        apllyToast('error', 'Problemas ao carregar dados do usuário');
        console.log(err);
      });

    return () => {
      active = false;
    };
  }, [id, isOpen]);

  useEffect(() => {
    if (!isOpen || !id) return;

    lossControlService
      .listOperatorResponsibilities(id)
      .then(responsibilities => {
        setLossControlScopes(
          responsibilities.map(responsibility => ({
            branchCode: responsibility.scope.branchCode,
            branchName: responsibility.scope.branchName,
            familyCode: responsibility.scope.familyCode,
            familyName: responsibility.scope.familyName,
            groupCode: responsibility.scope.groupCode,
            groupName: responsibility.scope.groupName,
            subgroupCode: responsibility.scope.subgroupCode,
            subgroupName: responsibility.scope.subgroupName,
          })),
        );
      })
      .catch(() => {
        apllyToast(
          'error',
          'Problemas ao carregar responsabilidades do Controle de Perdas',
        );
      });
  }, [id, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setInitialData({
        name: '',
        nickname: '',
        email: '',
        phone: '',
        ramal: '',
        image: '',
        job_position: '',
        sector_id: '',
        senior_id: '',
      });
      setSectorSelected({
        label: '',
        value: '',
      });
      setLossControlScopes([]);
    }
  }, [isOpen]);

  const selectedRolesView = withLabels(dataSelectesRoles, dataRoles);
  const selectedPermissionsView = withLabels(
    dataSelectesPermissions,
    dataPermissions,
  );
  const roleDiff = diffIds(
    initialRoleIdsRef.current,
    dataSelectesRoles.map(role => role.value),
  );
  const permissionDiff = diffIds(
    initialPermissionIdsRef.current,
    dataSelectesPermissions.map(permission => permission.value),
  );
  const hasLinkChanges =
    roleDiff.added.length +
      roleDiff.removed.length +
      permissionDiff.added.length +
      permissionDiff.removed.length >
    0;
  const nameOf = (options: IOptions[], ids: string[]) =>
    ids
      .map(value => options.find(option => option.value === value)?.label)
      .filter(Boolean)
      .join(', ');

  const handleSubmit = useCallback(
    async (data: IUserEdited) => {
      let accessUpdated = false;
      try {
        setLoading(true);
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string(),
          nickname: Yup.string(),
          email: Yup.string(),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        // const { name, nickname, email, phone, ramal, image } = data;
        // const formatData = {
        //   name,
        //   nickname,
        //   email,
        //   phone,
        //   ramal,
        //   image,
        // };

        await api.put('/accesses', { ...data, flag_1: flag_01 });
        accessUpdated = true;

        // Só mexe em funções e permissões se as atuais foram carregadas:
        // comparar com uma lista vazia removeria tudo do usuário. A API grava
        // as duas listas numa transação só.
        if (linksState === 'ready') {
          if (hasLinkChanges) {
            await accessControlService.syncAccessLinks(id, {
              roles_ids: dataSelectesRoles.map(role => role.value),
              permissions_ids: dataSelectesPermissions.map(
                permission => permission.value,
              ),
            });
          }
        } else {
          apllyToast(
            'warning',
            'Funções e permissões não foram alteradas porque não carregaram. Abra o usuário de novo.',
          );
        }

        await lossControlService.syncOperatorResponsibilities(
          id,
          lossControlScopes,
        );

        apllyToast('success', 'Dados atualizados');

        onClose();

        setLoading(false);
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          setLoading(false);

          formRef.current?.setErrors(errors);

          return;
        }
        setLoading(false);
        if (accessUpdated) {
          apllyToast(
            'warning',
            accessControlError(
              err,
              'Dados básicos salvos, mas um dos vínculos não foi atualizado. Abra o usuário e tente novamente.',
            ),
          );
        } else {
          apllyToast('error', 'Problemas ao atualizar o usuário');
        }
        onClose();
      }
    },
    [
      dataSelectesPermissions,
      dataSelectesRoles,
      flag_01,
      hasLinkChanges,
      id,
      linksState,
      lossControlScopes,
      onClose,
    ],
  );

  // O X na etiqueta tira da lista; a alteração vale ao salvar, junto com o
  // resto (e aparece no resumo "Alterações a salvar").
  const handleDeleteRole = useCallback((idRole: string) => {
    setSelectedDataRoles(current =>
      current.filter(item => item.value !== idRole),
    );
  }, []);

  const handleDeletePermission = useCallback((idPermission: string) => {
    setSelectedDataPermissions(current =>
      current.filter(item => item.value !== idPermission),
    );
  }, []);

  // Soma as funções e permissões de outro usuário às escolhidas aqui.
  const handleCopyFrom = async (sourceId: string) => {
    setCopyFrom(sourceId);

    if (!sourceId) {
      return;
    }

    setCopying(true);
    try {
      const links = await accessControlService.getAccessLinks(sourceId);
      const merge = (current: IOptions[], ids: string[]) =>
        toOptions(
          Array.from(new Set([...current.map(item => item.value), ...ids])),
        );

      setSelectedDataRoles(current => merge(current, links.roles_ids));
      setSelectedDataPermissions(current =>
        merge(current, links.permissions_ids),
      );
      apllyToast(
        'success',
        'Funções e permissões copiadas. Confira e clique em Salvar.',
      );
    } catch (err) {
      apllyToast(
        'error',
        accessControlError(err, 'Não foi possível copiar os acessos.'),
      );
    } finally {
      setCopying(false);
      setCopyFrom('');
    }
  };

  const statusPermissions: boolean = useMemo(() => {
    return dataSelectesPermissions.length > 0;
  }, [dataSelectesPermissions.length]);

  const statusRoles: boolean = useMemo(() => {
    return dataSelectesRoles.length > 0;
  }, [dataSelectesRoles.length]);

  return (
    <>
      <ModalComponent
        title="Editar usuário"
        isOpen={isOpen}
        onClose={onClose}
        scrollBehavior="inside"
      >
        <ModalBody>
          <Form ref={formRef} onSubmit={handleSubmit} initialData={initialData}>
            <p>Nome completo</p>
            <Input name="name" placeholder="Ex: Cristiano Mattei" />

            <p>Nome de acesso</p>
            <Input
              name="nickname"
              type="text"
              placeholder="Exemplo: cristiano.mattei"
            />
            <Select
              name="sector_id"
              label="Setor"
              initialData={sectorSelected}
              options={sectorFormated}
            />

            <p>Cargo</p>
            <Input
              type="text"
              name="job_position"
              placeholder="Exemplo: Vendedor de Varejo l"
            />
            <p>E-mail do usuário</p>
            <Input
              type="email"
              name="email"
              placeholder="Exemplo: antonio.fagundes@.empresa.com.br"
            />
            <p>Telefone</p>
            <Input type="text" name="phone" placeholder="Exemplo: 6791905052" />
            <p>Ramal</p>
            <Input
              type="text"
              name="ramal"
              placeholder="Exemplo: 8008"
              mb="1rem"
            />
            <p>Cod. cadastro senior</p>
            <Input type="text" name="senior_id" placeholder="1258" mb="1rem" />
            <p>Imagem</p>
            <Input name="image" placeholder="https://nome_do_user" />

            <Accordion allowToggle>
              <AccordionItem>
                {statusRoles && (
                  <p>
                    <AccordionButton>
                      <Box as="span" flex="1" textAlign="left">
                        Funções atribuidas
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </p>
                )}
                <AccordionPanel pb={4}>
                  {statusRoles
                    ? selectedRolesView.map(role => {
                        return (
                          <ListRoles
                            value={role.value}
                            key={role.value}
                            label={role.label}
                            handleDeleteRole={handleDeleteRole}
                          />
                        );
                      })
                    : ''}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>

            <Accordion allowToggle>
              <AccordionItem>
                {statusPermissions && (
                  <p>
                    <AccordionButton>
                      <Box as="span" flex="1" textAlign="left">
                        Permissões atribuidas
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </p>
                )}
                <AccordionPanel pb={4}>
                  {statusPermissions
                    ? selectedPermissionsView.map(permission => {
                        return (
                          <ListPermissions
                            value={permission.value}
                            key={permission.value}
                            label={permission.label}
                            handleDeletePermission={handleDeletePermission}
                          />
                        );
                      })
                    : ''}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
            <Box mt="1rem">
              {linksState === 'loading' && (
                <Flex align="center" gridGap="2" mb="2">
                  <Spinner size="sm" />
                  <Text fontSize="sm">Carregando funções e permissões...</Text>
                </Flex>
              )}
              {linksState === 'error' && (
                <Text fontSize="sm" color="red.400" mb="2">
                  Não foi possível carregar as funções e permissões deste
                  usuário. Elas não serão alteradas ao salvar.
                </Text>
              )}

              <p>Funções</p>
              <MultiSelect
                options={dataRoles}
                value={selectedRolesView}
                valueRenderer={selected => {
                  return selected.length
                    ? selected.map(({ label }) => `✔️ ${label}`)
                    : '😶 Nenhuma função selecionada';
                }}
                onChange={setSelectedDataRoles}
                labelledBy="Funções"
                hasSelectAll={false}
                filterOptions={filterOptions}
                disabled={linksState !== 'ready'}
                overrideStrings={Internationalization}
              />

              <Text mt="2">Permissões</Text>
              <MultiSelect
                options={dataPermissions}
                value={selectedPermissionsView}
                valueRenderer={selected => {
                  return selected.length
                    ? selected.map(({ label }) => `✔️ ${label}`)
                    : '😶 Nenhuma permissão selecionada';
                }}
                onChange={setSelectedDataPermissions}
                labelledBy="Permissões"
                hasSelectAll={false}
                filterOptions={filterOptions}
                disabled={linksState !== 'ready'}
                overrideStrings={Internationalization}
              />

              <Text mt="2">Copiar acessos de outro usuário</Text>
              <Flex align="center" gridGap="2">
                <SelectChakra
                  value={copyFrom}
                  onChange={event => handleCopyFrom(event.target.value)}
                  placeholder="Escolha um usuário com o mesmo papel"
                  isDisabled={linksState !== 'ready' || copying}
                >
                  {(accessUsers.data || [])
                    .filter(user => user.id !== id)
                    .map(user => (
                      <option key={user.id} value={user.id}>
                        {userLabel(user, true)}
                      </option>
                    ))}
                </SelectChakra>
                {copying && <Spinner size="sm" />}
              </Flex>
              <Text fontSize="xs" color="gray.500" mt="1">
                Soma as funções e permissões do outro usuário às deste. Bom para
                quem entra no mesmo cargo.
              </Text>

              {hasLinkChanges && (
                <Box
                  mt="3"
                  p="3"
                  borderRadius="6px"
                  borderWidth="1px"
                  borderColor="yellow.400"
                  fontSize="sm"
                >
                  <Text fontWeight="bold" mb="1">
                    Alterações a salvar
                  </Text>
                  {[
                    {
                      label: 'Funções que entram',
                      text: nameOf(dataRoles, roleDiff.added),
                    },
                    {
                      label: 'Funções que saem',
                      text: nameOf(dataRoles, roleDiff.removed),
                    },
                    {
                      label: 'Permissões que entram',
                      text: nameOf(dataPermissions, permissionDiff.added),
                    },
                    {
                      label: 'Permissões que saem',
                      text: nameOf(dataPermissions, permissionDiff.removed),
                    },
                  ]
                    .filter(line => line.text)
                    .map(line => (
                      <Text key={line.label}>
                        <b>{line.label}:</b> {line.text}
                      </Text>
                    ))}
                  <Text color="gray.500" mt="1">
                    {plural(
                      permissionDiff.added.length +
                        permissionDiff.removed.length +
                        roleDiff.added.length +
                        roleDiff.removed.length,
                      'alteração',
                      'alterações',
                    )}{' '}
                    · o usuário precisa atualizar a página do SAMASC para ver.
                  </Text>
                </Box>
              )}
            </Box>

            <Box mt="1rem">
              <ConfigsAvanced set_flag_01={set_flag_01} flag_01={flag_01} />
            </Box>
            <LossControlResponsibilitiesField
              value={lossControlScopes}
              onChange={setLossControlScopes}
              isDisabled={loading}
            />
            <ModalFooter>
              <Button variant="ghost" mr={3} onClick={onClose}>
                Fechar
              </Button>
              <Button colorScheme="blue" type="submit">
                {loading ? (
                  <div {...containerProps} ref={componentRef}>
                    {indicatorEl}
                  </div>
                ) : (
                  'Salvar'
                )}
              </Button>
            </ModalFooter>
          </Form>
        </ModalBody>
      </ModalComponent>
    </>
  );
}
